import {Component, OnInit} from '@angular/core';
import {environment} from '../../environments/environment';

import {HttpService} from '../services/HttpService';
import {NotificationService} from '../services/NotificationService';
import {FileUploadService} from '../services/FileUploadService';
import {AppComponent} from '../app.component';

import {AuthService} from 'angular4-social-login';
import {FacebookLoginProvider} from 'angular4-social-login';


@Component({
    selector: 'app-brand-profile',
    templateUrl: './brand-profile.component.html',
    styleUrls: ['./brand-profile.component.scss'],
    providers: [HttpService, NotificationService, FileUploadService, AuthService]
})
export class BrandProfileComponent implements OnInit {

    public apiUrl = environment.apiUrl;
    public User_Details: any;
    public brandDetails = {
        id: 0,
        name: '',
        email: '',
        phone: '',
        image_path: '',
        facebook_connected: 0
    }

    constructor(
        public http: HttpService,
        public notification: NotificationService,
        public app: AppComponent,
        public fileUpload: FileUploadService,
        private authService: AuthService
    ) {
    }

    ngOnInit() {
        this.User_Details = JSON.parse(localStorage.getItem('Admin_User_Details'));
        this.app.loading = true;
        this.http.makeRequestPost(['brand/admin/brands/image/getbrandetails',
            {
                token: this.User_Details.token,
                id: this.User_Details.brandadmins[0].id
            }
        ]).subscribe(
            (resp) => {
                this.app.loading = false;
                if (resp.data) {
                    this.brandDetails = resp.data;
                }
                if (resp.error) {
                    this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                }
            },
            (error) => {
                this.app.loading = false;
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
            }
        )
    }

    signInWithFB(): void {
        this.authService.signIn(FacebookLoginProvider.PROVIDER_ID)
        .then(
            (resp) => {
                console.log(resp);
                this.http.makeRequestPost(['admin/brands/user/connect',
                    {
                        token: this.User_Details.token,
                        id: this.User_Details.brandadmins[0].id
                    }
                ]).subscribe(
                    (resp) => {
                        this.app.loading = false;
                        if (resp.data) {
                            this.brandDetails = resp.data;
                        }
                        if (resp.error) {
                            this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                        }
                    },
                    (error) => {
                        this.app.loading = false;
                        this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
                    }
                )
            },
            (error) => {
                this.notification.showNotification('Could not connect your brand with Facebook', 'Error', 'error');
                console.log(error);
            }
        );
    }

    fileChange(event) {
        const selected = event.target.files && event.target.files[0];
        if (!this.fileUpload.isValidImageFile(selected)) {
            this.notification.showNotification('Please select an image file (JPG or PNG).', 'Invalid file', 'error');
            event.target.value = '';
            return;
        }
        this.app.loading = true;
        this.fileUpload.uploadFile('admin/user/brands/image/insert', event.target.files)
        .subscribe(
            (response) => {
                this.app.loading = false;
                console.log(response);
                if (response.data) {
                    this.brandDetails.image_path = response.data;
                } else {
                    this.notification.showNotification('Could not upload the image', 'Error', 'error');
                }
            },
            (error) => {
                this.app.loading = false;
                console.log(error);
                this.notification.showNotification('Could not upload the image', 'Error', 'error');
            }
        )
        //
    }

    updateBrand() {
        this.app.loading = true;
        this.http.makeRequestPost(['admin/user/brands/edit', {
            id: this.brandDetails.id,
            token: this.User_Details.token,
            name: this.brandDetails.name,
            email: this.brandDetails.email,
            phone: this.brandDetails.phone,
            image_path: this.brandDetails.image_path,
        }])
        .subscribe(
            (response) => {
                this.app.loading = false;
                if (response.data) {
                    this.brandDetails = response.data;
                    this.notification.showNotification('Brand details updated', 'Success', 'success');
                }
                if (response.error) {
                    this.notification.showNotification('Could not edit the brand details', 'Error', 'error');
                }
            },
            (error) => {
                this.app.loading = false;
                this.notification.showNotification('Please make sure you have a working data connection', 'Error', 'error');
            }
        )
    }

}



// WEBPACK FOOTER //
// ./src/app/brand-profile/brand-profile.component.ts